import React  from 'react';
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

import MongodbHost from './component/mongodb/MongodbHost';
import MongodbConnection from './component/mongodb/MongodbConnection';
import MongodbGridFS from './component/mongodb/MongodbGridFS';

import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common';

class SettingMongoDB extends React.Component {
	componentWillMount() {
		this.props.fetchSettingDataInfo(this.props.settingKey.mongodbHost.value )
		this.props.fetchSettingDataInfo(this.props.settingKey.mongodbAuth.value, this.props.settingKey.mongodbAuth.keyList, this.props.apps)
		this.props.fetchSettingDataInfo(this.props.settingKey.mongodbGridFS.value, this.props.settingKey.mongodbGridFS.keyList, null)
	}

	onSaveMongodbHost = (isSingle, value) => {
		this.props.fetchSettingDataUpdate(isSingle, value, {type: types.FETCH_GET_SETTING_DATA_INFO_REQUEST, key: this.props.settingKey.mongodbHost.value})
	}

	onSaveMongodbConnection = (isSingle, value) => {
		this.props.fetchSettingDataUpdate(isSingle, value, 
			{
				type: types.FETCH_GET_SETTING_DATA_INFO_REQUEST,
				key: this.props.settingKey.mongodbAuth.value,
				keyList: this.props.settingKey.mongodbAuth.keyList,
				appList: this.props.apps
			})
	}

	onSaveMongodbGridFS = (isSingle, value) => {
		this.props.fetchSettingDataUpdate(isSingle, value, 
			{
				type: types.FETCH_GET_SETTING_DATA_INFO_REQUEST,
				key: this.props.settingKey.mongodbGridFS.value,
				keyList: this.props.settingKey.mongodbGridFS.keyList,
				appList: null
			})
	}

	render() {
		const {t} = this.props;
		return (
			<div>
				{this.props.isNullCheck(this.props.settingData.mongodbHost) ? null : 
					<MongodbHost
						t = {this.props.t}
						apps={this.props.apps}
						settingKey={this.props.settingKey.mongodbHost}
						settingData={this.props.settingData.mongodbHost}
						alertMessage={this.props.alertMessage}
						onSave={this.onSaveMongodbHost}
					/>
				}
				{isEmpty(this.props.settingData.mongodbAuth) ? null : 
					<MongodbConnection
						t = {this.props.t}
						apps={this.props.apps}
						settingKey={this.props.settingKey.mongodbAuth}
						settingData={this.props.settingData.mongodbAuth}
						alertMessage={this.props.alertMessage}
						onSave={this.onSaveMongodbConnection}
					/>
				}
				{isEmpty(this.props.settingData.mongodbGridFS) ? null : 
					<MongodbGridFS
						t = {this.props.t}
						apps={this.props.apps}
						settingKey={this.props.settingKey.mongodbGridFS}
						settingData={this.props.settingData.mongodbGridFS}
						alertMessage={this.props.alertMessage}
						onSave={this.onSaveMongodbGridFS}
					/>
				}
			</div>
		)
	}


}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return {	
		apps: reducers.setting.apps,
		settingKey: reducers.setting.settingKey,
		settingData: reducers.setting.settingData,
		apiCalling: reducers.apiCalling.apiCalling
	}
}

// 컴포넌트의 함수형 props를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return {
		fetchSettingDataInfo: (key, keyList, appList) => {dispatch({type: types.FETCH_GET_SETTING_DATA_INFO_REQUEST, key: key, keyList: keyList, appList: appList})},
		fetchSettingDataUpdate: (isSingle, value, reloadAction) => {dispatch({type: types.FETCH_SET_SETTING_DATA_UPDATE_REQUEST, isSingle: isSingle, value: value, reload: reloadAction})},	
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SettingMongoDB))